<template>
    <div class="feedback-form">
        <p class="h5 mb-32">Остались вопросы по аренде оборудования? <br> Оставьте Ваше сообщение здесь и получите консультацию!</p>
        <div class="row mb-32">
            <div class="col-sm-6">
                <div class="mb-24 input-box">
                    <label for="post_name" class="color-text-label" :class="{'error-form': $v.postData.name.$error}">Ваше имя*</label>
                    <input id="post_name" class="max-w-full" type="text"
                           @input="delayTouch($v.postData.name)"
                           v-model.trim="postData.name">
                    <div class="error-box">
                        <div class="h6 pt-1 error-form" v-if="$v.postData.name.$error && !$v.postData.name.required">Поле обязательно для заполнения</div>
                    </div>
                </div>

                <div class="mb-24 input-box">
                    <label for="post_email" class="color-text-label" :class="{'error-form': $v.postData.email.$error}">Ваше e-mail*</label>
                    <input id="post_email" class="max-w-full" type="text"
                           @input="delayTouch($v.postData.email)"
                           v-model.trim="postData.email">
                    <div class="error-box">
                        <div class="h6 pt-1 error-form" v-if="$v.postData.email.$error && !$v.postData.email.required">Поле обязательно для заполнения</div>
                        <div class="h6 pt-1 error-form" v-if="$v.postData.email.$error && !$v.postData.email.email && postData.email">Неверный формат e-mail</div>
                    </div>
                </div>

                <div class="input-box mb-4 mb-sm-0">
                    <label for="post_topic" class="color-text-label">Тема</label>
                    <input id="post_topic" class="max-w-full" type="text" v-model.trim="postData.topic">
                </div>
            </div>

            <div class="col-sm-6">
                <div class="input-box textarea-box">
                    <label for="post_text" class="color-text-label" :class="{'error-form': $v.postData.text.$error}">Сообщение*</label>
                    <textarea id="post_text" type="text" class="max-w-full"
                              @input="delayTouch($v.postData.text)"
                              v-model.trim="postData.text"></textarea>
                    <div class="error-box">
                        <div class="h6 pt-1 error-form" v-if="$v.postData.text.$error && !$v.postData.text.required">Поле обязательно для заполнения</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-center text-sm-right">
            <button @click=saveData() class="button btn-v2 btn-large">Отправить сообщение</button>
        </div>
    </div>
</template>

<script>
    import { requiredRule, emailReqRule } from '../services/validation';
    export default {
        data() {
            return {
                loading: false,
                postData: {
                    name: null,
                    email: null,
                    topic: null,
                    text: null
                }
            }
        },

        methods: {
            saveData() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ошибка',
                        html: 'Проверьте правильность внесенных данных',
                    });
                    return false;
                } else {
                    this.loading = true;
                    let url = '/api/contact-feedback';
                    const options = {
                        headers: {Authorization: "Bearer " + localStorage.getItem('token')},
                    };

                    axios.post(url, this.postData, options)
                        .then(response => {
                            if(response.status == 200) {
                                this.loading = false;
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Готово!',
                                    html: `Ваше сообщение успешно отправлено. <br> Мы свяжемся с Вами в ближайшее время.`,
                                })
                            }
                        })
                        .catch(() => {
                            this.loading = false
                        })
                }
            },
            delayTouch($v) {
                $v.$reset();
                if (touchMap.has($v)) {
                    clearTimeout(touchMap.get($v))
                }
                touchMap.set($v, setTimeout($v.$touch, 1000))
            }
        },

        validations: {
            postData: {
                name: requiredRule,
                email: emailReqRule,
                text: requiredRule
            }
        }
    }
</script>
